import React from 'react';
import './TitleAdmin.css';

export const TitleAdmin = () => {
  return (
    <div className='title_admin'>
      <h1>Admin</h1>
      <h2>Usuarios</h2>
    </div>
  )
}
